App.SettingsController = Em.Controller.extend
  session: Em.inject.service()